import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceTipoEquipamento = {
  ...serviceReutils({ name: 'rotas/v1/tipoEquipamento', api }),
};
